import React from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Numeros.css';

const getSchema = (rota, type) => {
  const schemaMap = {
    '7-8': { par: 7, impar: 8 },
    '8-7': { par: 8, impar: 7 },
    '6-9': { par: 6, impar: 9 },
    '9-6': { par: 9, impar: 6 },
    '5-10': { par: 5, impar: 10 },
    '10-5': { par: 10, impar: 5 },
  };
  return schemaMap[rota]?.[type];
};

const getTipo = (choice) => {
  return choice.toLowerCase() === 'par' ? 'Par' : 'Impar';
};

const JogosGerados = () => {
  const location = useLocation();
  const { jogos, choice, rota } = location.state || {};

  if (!choice || !rota) {
    return <div>Error: Choice or Rota is undefined.</div>;
  }

  const createFile = (fileName, fileContent) => {
    const element = document.createElement("a");
    const file = new Blob([fileContent], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
  };

  const handleSalvarJogos = () => {
    const tipo = getTipo(choice);
    const fileName = `Jogos-${getSchema(rota, 'par')}-${getSchema(rota, 'impar')}-${tipo}.ltc`;
    const fileContent = btoa(jogos.map(jogo => jogo.join(', ')).join('\n'));
    createFile(fileName, fileContent);
  };

  const handleExportarTxt = () => {
    const tipo = getTipo(choice);
    const fileName = `Jogos-${getSchema(rota, 'par')}-${getSchema(rota, 'impar')}-${tipo}.txt`;
    const fileContent = jogos.map(jogo => jogo.map(num => num.toString().padStart(2, '0')).join(' ')).join('\n');
    createFile(fileName, fileContent);
  };

  return (
    <div className="container">
      <h2 className="jogos-gerados">Jogos Gerados</h2>
      <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Jogos</th>
            </tr>
          </thead>
          <tbody>
            {jogos.map((jogo, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{jogo.map(num => num.toString().padStart(2, '0')).join(' ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="btn-group mt-3" role="group" aria-label="Basic outlined example">
        <button
          id="salvar"
          type="button"
          className="btn btn-outline-primary"
          onClick={handleSalvarJogos}
        >
          Salvar
        </button>
        <button
          id="exportarTxt"
          type="button"
          className="btn btn-outline-primary"
          onClick={handleExportarTxt}
        >
          Exportar Txt
        </button>
      </div>
    </div>
  );
};

export default JogosGerados;
